import React from 'react';
import { default as bemCssModules } from 'bem-css-modules';
import * as AddToBasketEvent from '@ori-events/add-to-basket';
import * as AddToBasketFailedEvent from '@ori-events/add-to-basket-failed';
import * as BasketUpdatedEvent from '@ori-events/basket-updated';
import { v4 } from 'uuid';
import { default as QuickBuyStyles } from './QuickBuy.module.css';
const style = bemCssModules(QuickBuyStyles);
const ERROR_REMOVAL_TIMEOUT = 300;
const SUCCESS_REMOVAL_TIMEOUT = 2000;
export const QuickBuy = (props) => {
    const [isSuccess, setSuccess] = React.useState(false);
    const [isWaiting, setWaiting] = React.useState(false);
    const [isInProgress, setInProgress] = React.useState(false);
    const [isError, setError] = React.useState(false);
    const addToBasket = (code) => (event) => {
        event.stopPropagation();
        setInProgress(true);
        const addtoBasketEvent = new CustomEvent(AddToBasketEvent.Name, {
            detail: {
                itemCode: code,
                quantity: 1,
            },
        });
        window.dispatchEvent(addtoBasketEvent);
    };
    const onBasketUpdated = (event) => {
        var _a;
        if (((_a = event.detail.lastAddedItem) === null || _a === void 0 ? void 0 : _a.itemCode) !== props.code) {
            setWaiting(false);
            return;
        }
        setInProgress(false);
        setSuccess(true);
        setTimeout(() => setSuccess(false), SUCCESS_REMOVAL_TIMEOUT);
    };
    const onAddToBaskedFailed = () => {
        setWaiting(false);
        setInProgress(false);
        setError(true);
        setTimeout(() => {
            setError(false);
        }, ERROR_REMOVAL_TIMEOUT);
    };
    const onOtherAddToBasket = (event) => {
        if (event.detail.itemCode !== props.code) {
            setWaiting(true);
            return;
        }
        setInProgress(true);
    };
    React.useEffect(() => {
        window.addEventListener(AddToBasketEvent.Name, onOtherAddToBasket);
        window.addEventListener(BasketUpdatedEvent.Name, onBasketUpdated);
        window.addEventListener(AddToBasketFailedEvent.Name, onAddToBaskedFailed);
        return () => {
            window.addEventListener(AddToBasketEvent.Name, onOtherAddToBasket);
            window.removeEventListener(BasketUpdatedEvent.Name, onBasketUpdated);
            window.removeEventListener(AddToBasketFailedEvent.Name, onAddToBaskedFailed);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const icon = () => {
        const id = v4();
        if (isError) {
            return (React.createElement("svg", { version: "1.1", xmlns: "http://www.w3.org/2000/svg", width: "25", height: "26", viewBox: "0 0 43 64" },
                React.createElement("path", { d: "M41.26 29.1c-0.22-2.191-2.191-3.975-4.394-3.975h-4.125v-2.75c0-6.064-4.936-11-11-11s-11 4.936-11 11v2.75h-4.125c-2.202 0-4.173 1.783-4.394 3.975l-2.202 22.027c-0.11 1.12 0.231 2.181 0.967 2.992 0.73 0.811 1.754 1.257 2.879 1.257h35.75c1.125 0 2.148-0.446 2.879-1.257 0.736-0.811 1.077-1.872 0.967-2.992l-2.202-22.027zM13.491 22.375c0-4.549 3.701-8.25 8.25-8.25s8.25 3.701 8.25 8.25v2.75h-16.5v-2.75zM40.459 52.273c-0.207 0.228-0.505 0.352-0.843 0.352h-35.75c-0.338 0-0.636-0.124-0.843-0.352-0.204-0.228-0.298-0.537-0.263-0.873l2.202-22.027c0.078-0.8 0.854-1.498 1.654-1.498h30.25c0.8 0 1.576 0.698 1.654 1.499l2.202 22.027c0.035 0.336-0.059 0.645-0.263 0.873z" })));
        }
        if (isInProgress) {
            return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", viewBox: "0 0 20 20" },
                React.createElement("defs", null,
                    React.createElement("linearGradient", { id: `spinner-fill-${id}`, x1: "-0.019", y1: "0.75", x2: "0.911", y2: "0.887", gradientUnits: "objectBoundingBox" },
                        React.createElement("stop", { offset: "0", stopColor: "#bac5b9", stopOpacity: "0" }),
                        React.createElement("stop", { offset: "1", stopColor: "#bac5b9" }))),
                React.createElement("path", { style: {
                        fillRule: 'evenodd',
                        fill: `url(#spinner-fill-${id})`,
                    }, d: "M20.412,962.766a10.224,10.224,0,0,0-10.009,10,11.959,11.959,0,0,0,.1,1.425c.187,1.222.849,1.508,1.4,1.46a.985.985,0,0,0,.7-.365,1.092,1.092,0,0,0,.191-.886c-.013-.057-.018-.12-.026-.174a7.667,7.667,0,0,1-.156-1.46,7.782,7.782,0,1,1,5.074,7.3,1.108,1.108,0,1,0-.877,2.033,9.043,9.043,0,0,0,3.606.669,9.988,9.988,0,0,0,9.991-10A10.317,10.317,0,0,0,20.412,962.766Z", transform: "translate(-10.403 -962.766)" })));
        }
        if (isSuccess) {
            return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "18", height: "18", enableBackground: "new 0 0 24 24", viewBox: "0 0 24 24", xmlSpace: "preserve" },
                React.createElement("polyline", { fill: "none", points: "23,4 7.5,20 0,12", stroke: "#89cd7a", strokeMiterlimit: "10", strokeWidth: "1.5" })));
        }
        return (React.createElement("svg", { version: "1.1", xmlns: "http://www.w3.org/2000/svg", width: "25", height: "26", viewBox: "0 0 43 64" },
            React.createElement("path", { d: "M41.26 29.1c-0.22-2.191-2.191-3.975-4.394-3.975h-4.125v-2.75c0-6.064-4.936-11-11-11s-11 4.936-11 11v2.75h-4.125c-2.202 0-4.173 1.783-4.394 3.975l-2.202 22.027c-0.11 1.12 0.231 2.181 0.967 2.992 0.73 0.811 1.754 1.257 2.879 1.257h35.75c1.125 0 2.148-0.446 2.879-1.257 0.736-0.811 1.077-1.872 0.967-2.992l-2.202-22.027zM13.491 22.375c0-4.549 3.701-8.25 8.25-8.25s8.25 3.701 8.25 8.25v2.75h-16.5v-2.75zM40.459 52.273c-0.207 0.228-0.505 0.352-0.843 0.352h-35.75c-0.338 0-0.636-0.124-0.843-0.352-0.204-0.228-0.298-0.537-0.263-0.873l2.202-22.027c0.078-0.8 0.854-1.498 1.654-1.498h30.25c0.8 0 1.576 0.698 1.654 1.499l2.202 22.027c0.035 0.336-0.059 0.645-0.263 0.873z" })));
    };
    return (React.createElement("div", { className: style(null, {
            'is-waiting': isWaiting,
            'is-in-progress': isInProgress,
            'is-success': isSuccess,
        }), onClick: addToBasket(props.code) }, icon()));
};
